import SpeakerDropdown from 'containers/SubSidebar/shared/Voices/SpeakerDropdown'
import { memo, useCallback, useContext } from 'react'
import { TtsItemSpeakerFlyoutContext } from '../../contextApi'
import { TtsItemContext } from '../../../contextApi'
import { TTS_SPEAKER_ITEM_CLASS_NAME } from '../../../consts'
import {
  useGetTtsSpeakers,
  usePremiumVoiceHandler
} from 'containers/SubSidebar/shared/Voices/hooks'

const TtsItemSpeakerDropdown: React.FC = () => {
  const { ttsActiveSpeakerId, handleVoiceChange, ttsItemLangCode } = useContext(
    TtsItemSpeakerFlyoutContext
  )

  const { ttsSpeakers, isSpeakersLoading } = useGetTtsSpeakers(ttsItemLangCode)

  const { scrollableParentRef } = useContext(TtsItemContext)
  const { handleVoiceSelection } = usePremiumVoiceHandler({
    speakers: ttsSpeakers || [],
    onVoiceSelect: (speakerId: number) => {
      handleVoiceChange(speakerId)
    }
  })

  const onSpeakerVoiceClick = useCallback(
    (currentSpeakerId: number) => {
      handleVoiceSelection(currentSpeakerId)
    },
    [handleVoiceSelection]
  )

  return (
    <SpeakerDropdown
      isDataLoading={isSpeakersLoading}
      speakersData={ttsSpeakers}
      selectedSpeakerId={ttsActiveSpeakerId}
      onSpeakerClick={onSpeakerVoiceClick}
      scrollableParentRef={scrollableParentRef}
      childClassName={TTS_SPEAKER_ITEM_CLASS_NAME}
    />
  )
}

export default memo(TtsItemSpeakerDropdown)
